import { render } from "./BlockStatXlsx.vue?vue&type=template&id=788687c6"
import script from "./BlockStatXlsx.vue?vue&type=script&lang=js"
export * from "./BlockStatXlsx.vue?vue&type=script&lang=js"

import "./BlockStatXlsx.vue?vue&type=style&index=0&id=788687c6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__